import { render, staticRenderFns } from "./CatalogItem.vue?vue&type=template&id=052e11df"
import script from "./CatalogItem.vue?vue&type=script&lang=js"
export * from "./CatalogItem.vue?vue&type=script&lang=js"
import style0 from "./CatalogItem.vue?vue&type=style&index=0&id=052e11df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports